import { ELEM_TYPES } from './constants/ElementTypes'
import _ from 'lodash'
import { fromJS, List } from 'immutable'
import { LIST_BASED_FIELDS } from '../constants/LIST_BASED_FIELDS'
import { detectIsTargetKeyInRepeatEl, setValueForElementType, updateState } from './StateUtils'
import { getElementDataRoot } from '../constants/getElementDataRoot'

export const getDefaultValueForFormFieldByType = (elem, layoutMode, elemType) => {
  try {
    const defaultVal = elem.getIn(['props', layoutMode, 'value'])
    const listElemWithDefaultVal = _.find(elem.getIn(['props', 'items'])?.toJS(), (item) => item.value === defaultVal)
    if ([ELEM_TYPES.CHECKBOX, ELEM_TYPES.SWITCH].includes(elemType)) {
      return defaultVal || false
    } else if (elemType === ELEM_TYPES.MULTISELECT) {
      return { ftListValue: defaultVal || '' }
    } else if (elemType === ELEM_TYPES.TEXT) {
      return defaultVal || ''
    } else {
      return {
        ftListValue: listElemWithDefaultVal?.value || '',
        ftListLabel: listElemWithDefaultVal?.label || '',
      }
    }
  } catch (e) {
    return ''
  }
}

const resetFileUpload = (elUID, index) => {
  const files = window?.__FT_PROJECT__API__FILES__?.files
  if (!files || !files[elUID]) return
  if (index != null && typeof index !== 'undefined') {
    files[elUID][index] = {}
  } else {
    files[elUID] = {}
  }
}

export const setResetValueOnAction = (elemType, elUID, index, elementData, layoutMode, action) => {
  // set action reset value for different elements
  if (elemType === ELEM_TYPES.FILE_UPLOAD) {
    resetFileUpload(elUID, index)
    return action
  } else if (LIST_BASED_FIELDS.includes(elemType) || elemType === ELEM_TYPES.CHECKBOX) {
    const defaultVal = getDefaultValueForFormFieldByType(elementData, layoutMode, elemType)
    return action.set('value', fromJS(defaultVal))
  } else {
    return action.set('value', elementData.getIn(['props', layoutMode, 'value']))
  }
}

export const updateResetStateForRepeatElements = (keyPath, index, elemType, retState, action, elementData) => {
  const statePath = _.initial(keyPath)
  const additionalPath = index !== null && typeof index !== 'undefined' ? [index] : []
  if (elemType === ELEM_TYPES.BUTTON) {
    retState = retState.setIn(['state', ...statePath, 'BTN_TEXT', ...additionalPath], action.get('value'))
  } else if (elemType === ELEM_TYPES.IMAGE) {
    retState = retState.setIn(['state', ...statePath, 'IMG_SRC', ...additionalPath], action.get('value'))
  } else if (elemType === ELEM_TYPES.TYPOGRAPHY) {
    retState = retState.setIn(['state', ...statePath, 'TYPO_TEXT', ...additionalPath], action.get('value'))
  } else if ([ELEM_TYPES.YOUTUBE, ELEM_TYPES.VIMEO].indexOf(elemType) !== -1) {
    retState = updateState(retState, [...statePath, ...additionalPath], action.get('value'))
  } else {
    if (elemType === ELEM_TYPES.CHECKBOX) {
      if (elementData.getIn(['props', 'source']) === 'static') {
        retState = updateState(retState, [...statePath, 'ftListValue', ...additionalPath], action.get('value'))
        retState = updateState(
          retState,
          [...statePath, 'selectedCount', ...additionalPath],
          action.get('value').split(';').length
        )
      }
      if (elementData.getIn(['props', 'source']) === 'single') {
        retState = updateState(retState, [...statePath, ...additionalPath], action.get('value'))
      }
    } else if (elemType === ELEM_TYPES.MULTISELECT) {
      if (elementData.getIn(['props', 'source']) === 'static') {
        retState = updateState(
          retState,
          [...statePath, 'ftListValue', ...additionalPath],
          action.getIn(['value', 'ftListValue'])
        )
        retState = updateState(
          retState,
          [...statePath, 'selectedCount', ...additionalPath],
          action.getIn(['value', 'ftListValue']).split(';').length
        )
      }
    } else if (elemType === ELEM_TYPES.RADIO) {
      // for radio button - the state structure is different:
      // (index -> value object)
      const defaultRadioValue = fromJS({
        ftListValue: action.getIn(['value', 'ftListValue']),
        ftListLabel: action.getIn(['value', 'ftListLabel']),
      })
      retState = setValueForElementType(retState, statePath, additionalPath, defaultRadioValue)
    } else if (LIST_BASED_FIELDS.includes(elemType)) {
      retState = updateState(
        retState,
        [...statePath, 'ftListLabel', ...additionalPath],
        action.getIn(['value', 'ftListLabel'])
      )
      retState = updateState(
        retState,
        [...statePath, 'ftListValue', ...additionalPath],
        action.getIn(['value', 'ftListValue'])
      )
    } else {
      retState = updateState(retState, [...statePath, ...additionalPath], action.get('value'))
    }
  }
  if (keyPath[0] && keyPath[1]) {
    retState = retState.setIn(
      ['formFieldStatuses', keyPath[0], keyPath[1]],
      fromJS({
        status: '',
        error: '',
        errorCode: '',
      })
    )
  }
  return retState
}

export const resetTabValue = (keyPath, retState, action, isBtnRepeat, index) => {
  const [pageID, id1, id2, ...rest] = keyPath
  const isPossibleRepeat = detectIsTargetKeyInRepeatEl(keyPath, retState)
  let page = retState.hasIn(['project', 'Settings', 'elements', id1]) ? 'project' : retState.get('page')
  let uid = null
  let tab = action.get('value')
  let el1Type = retState.getIn([...getElementDataRoot(page), 'elements', id1, 'type'])
  let el2Type = retState.getIn([...getElementDataRoot(page), 'elements', id2, 'type'])
  if (el1Type === 'Tab') {
    uid = id1
  } else if (el2Type === 'Tab') {
    uid = id2
  }
  if (uid && tab) {
    retState = retState.setIn(
      ['__cache__'],
      retState.getIn(['__cache__'], List()).push(
        fromJS({
          type: 'activateTab',
          payload: {
            uid,
            tab,
            ...(isPossibleRepeat
              ? {
                  isRepeat: isBtnRepeat,
                  index,
                }
              : {}),
          },
        })
      )
    )
  }
  return retState
}
